import { normalizeTimelineEventType } from './timelineEvents';

/** Allowed values for `v3_report_entries.current_status` (see DB constraint). */
export const CASE_STATUS_OPTIONS = [
  'Pending', 'Recommendation Approval', 'Recommendation Denial',
  'Approved', 'Denied', 'Withdrawn', 'Unknown',
]

/**
 * Four top-level filter groups. Each group key maps to the `current_status`
 * values it includes. "Pending" is the broad bucket that also covers the
 * two recommendation statuses.
 */
export const STATUS_FILTER_GROUPS = {
  Pending: ['Pending', 'Recommendation Approval', 'Recommendation Denial'],
  Approved: ['Approved'],
  Denied: ['Denied'],
  Withdrawn: ['Withdrawn'],
  Unknown: ['Unknown'],
}

/** Short badge labels shown on cards / chips. */
export const STATUS_BADGE_LABELS = {
  Pending: 'PENDING',
  'Recommendation Approval': 'REC. APPROVAL',
  'Recommendation Denial': 'REC. DENIAL',
  Approved: 'APPROVED',
  Denied: 'DENIED',
  Withdrawn: 'WITHDRAWN',
  Unknown: 'UNKNOWN',
}

/** Canonical hex per status (timeline, chips, filter pills). */
export const CASE_STATUS_COLORS = {
  Pending: '#ca8a04',
  Approved: '#10b981',
  Denied: '#ef4444',
  Withdrawn: '#78716c',
  'Recommendation Approval': '#6ee7b7',
  'Recommendation Denial': '#fca5a5',
  Submitted: '#0ea5e9',
  Unknown: '#a1a1aa',
}

const FALLBACK_STATUS_COLOR = '#7454A5'

/** Hex color for timeline chips and Gantt row styling. */
export function getCaseStatusColor(status) {
  const key = status === 'Continuing' ? 'Pending' : status
  if (key && Object.prototype.hasOwnProperty.call(CASE_STATUS_COLORS, key)) {
    return CASE_STATUS_COLORS[key]
  }
  return FALLBACK_STATUS_COLOR
}

const EVENT_TYPE_COLOR_KEYS = {
  pending: 'Pending',
  continuing: 'Pending',
  initial_filing: 'Submitted',
  recommendation_approval: 'Recommendation Approval',
  recommendation_denial: 'Recommendation Denial',
  approved: 'Approved',
  denied: 'Denied',
  withdrawn: 'Withdrawn',
}

/** Final-outcome event types (approval, denial, withdrawal). */
export function isTerminalTimelineEventType(eventType) {
  const t = String(eventType || '').toLowerCase()
  return t === 'approved' || t === 'denied' || t === 'withdrawn'
}

/** Timeline event bubble color by `event_type` (lowercase). */
export function getTimelineEventColor(eventType) {
  const t = normalizeTimelineEventType(eventType)
  const key = EVENT_TYPE_COLOR_KEYS[t]
  if (key && Object.prototype.hasOwnProperty.call(CASE_STATUS_COLORS, key)) {
    return CASE_STATUS_COLORS[key]
  }
  return FALLBACK_STATUS_COLOR
}

/** @deprecated Use getTimelineEventColor instead. */
export const getTimelineTier1EventColor = getTimelineEventColor
